import styled from "styled-components";
import { Button } from "styled/Buttons";

export const TableRowButton = styled(Button.Notification)`
  padding: 0;
`;
